import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { countrySchema } from "./schema";
import { fetchCountryData } from "./read";
import { useUpdateCountry } from "../update/mutation";
import { useCreateCountry } from "../create/mutation";

export const useCountryForm = ({ countryId }) => {
  const form = useForm({
    resolver: zodResolver(countrySchema),
    defaultValues: {
      name: "",
    },
  });

  const updateCountry = useUpdateCountry();
  const createCountry = useCreateCountry();

  const handleCreate = async (context) => {
    const item = context.values;
    await createCountry.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    await updateCountry.mutateAsync({ countryId: id, item: values });
  };

  const handleRead = async (id) => {
    const response = await fetchCountryData({ countryId: id });
    return response;
  };

  return {
    form,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
